const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Make an authenticated fetch request
 * 
 * @param {string} endpoint - API endpoint (e.g., '/concerns/all')
 * @param {object} options - Fetch options (method, body, etc.)
 * @returns {Promise} - Fetch promise
 */
export const authenticatedFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    throw new Error('No authentication token found');
  }

  // Merge headers with Authorization
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
    ...options.headers
  };

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers
  });

  // Check if token expired (401 Unauthorized)
  if (response.status === 401) {
    // Token expired or invalid - clear storage and redirect to login
    localStorage.removeItem('token');
    localStorage.removeItem('user_info');
    window.location.href = '/login';
    throw new Error('Session expired. Please login again.');
  }
  return response;
};

/**
 * Helper functions for common HTTP methods
 */
export const api = {
  get: (endpoint) => authenticatedFetch(endpoint, { method: 'GET' }),
  
  post: (endpoint, data) => authenticatedFetch(endpoint, {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  
  put: (endpoint, data) => authenticatedFetch(endpoint, {
    method: 'PUT',
    body: JSON.stringify(data)
  }),
  
  delete: (endpoint) => authenticatedFetch(endpoint, { method: 'DELETE' })
};
